import { getThreadMessages } from './get-thread-messages';
export var getLastThreadMessage = function (state, filterFn) {
    return function (threadId) {
        if (!filterFn) {
            filterFn = function () { return true; };
        }
        var messages = getThreadMessages(state)(threadId).filter(filterFn);
        return messages[messages.length - 1];
    };
};
